import { useState, useEffect, useRef } from "react";
import AccordionBarChart from "../../../AccordionBarChart/AccordionBarChart";
import UserStore from "../../../../store/UserStore";
import AnalyticsStore from "../../../../store/AnalyticsStore";
import EmptyScreen from "../../Equity/EmptyScreen/EmptyScreen";
//import Dropdown from "../../Equity/Dopdown/Dropdown";
import { setCookie, getCookie } from "../../../../utils/cookie";
import RadioDropdown from "../../Equity/Dopdown/RadioDropdown";

const CategoryExposure = ({
  amcData,
  marketCapDropdownItems,
  marketCapDropdownItems1,
  selectedAccount1,
  selectedAccount2,
  userId,
  categoryData,
  setSelectedAccount1,
  setSelectedAccount2,
}) => {
  // const marketCapDropdownItems = [
  //   { id: 0, value: "Across Categories" },
  //   { id: 2, value: "Equity" },
  //   { id: 4, value: "Fixed Income" },
  // ];

  // const marketCapDropdownItems1 = [
  //   { is: 0, value: "Across Categories" },
  //   { id: 2, value: "Equity" },
  //   { id: 4, value: "Fixed Income" },
  // ];

  // const [amcData, setAmcData] = useState([]);
  // const [categoryData, setCategoryData] = useState([]);
  const [amcExposureCount, setAmcExposureCount] = useState(6);
  const [categoryExposureCount, setCategoryExposureCount] = useState(6);

  const amcExposureDropdownButtonRef = useRef(null);
  const amcExposureDropdownContainerRef = useRef(null);

  const mfCategoryExposureDropdownButtonRef = useRef(null);
  const mfCategoryExposureDropdownContainerRef = useRef(null);

  // const [selectedAccount1, setSelectedAccount1] = useState(
  //   marketCapDropdownItems[0]
  // );

  // const [selectedAccount2, setSelectedAccount2] = useState(
  //   marketCapDropdownItems1[0]
  // );

  // const isPrimary =
  //   (AnalyticsStore?.overall?.isPrimary ||
  //     JSON.parse(getCookie("isPrimary"))) &&
  //   UserStore.getData === "fam"
  //     ? true
  //     : false;
  // const userId =
  //   !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));

  useEffect(() => {
    let familyId = UserStore?.userData?.family_id;
    let userId = UserStore?.userData?.user_id;
    if (familyId) {
      setCookie("familyId", familyId);
    } else {
      familyId = getCookie("familyId");
    }
    if (!userId) {
      userId = getCookie("userid");
    }

    setSelectedAccount1(marketCapDropdownItems[0]);
    setSelectedAccount2(marketCapDropdownItems1[0]);
    // eslint-disable-next-line
  }, [userId]);

  const [amcMenuOpen, setAmcMenuOpen] = useState(false);
  const [categoryMenuOpen, setcategoryMenuOpen] = useState(false);

  // useEffect(() => {
  //   let familyId = UserStore?.userData?.family_id;
  //   let userId = UserStore?.userData?.user_id;
  //   if (familyId) {
  //     setCookie("familyId", familyId);
  //   } else {
  //     familyId = getCookie("familyId");
  //   }
  //   if (!userId) {
  //     userId = getCookie("userid");
  //   }
  //   setAmcData([]);
  //   AnalyticsStore.setOverall({
  //     ...AnalyticsStore.overall,
  //     amcExposureLoading: true,
  //   });
  //   getAmcExposure(familyId, userId, selectedAccount1.id).then((response) => {
  //     setAmcData(response.data);
  //     AnalyticsStore.setOverall({
  //       ...AnalyticsStore.overall,
  //       amcExposure: response.data,
  //       amcExposureLoading: false,
  //     });
  //   });
  // }, [selectedAccount1]);

  // useEffect(() => {
  //   let familyId = UserStore?.userData?.family_id;
  //   let userId = UserStore?.userData?.user_id;
  //   if (familyId) {
  //     setCookie("familyId", familyId);
  //   } else {
  //     familyId = getCookie("familyId");
  //   }
  //   if (!userId) {
  //     userId = getCookie("userid");
  //   }
  //   setCategoryData([]);
  //   AnalyticsStore.setOverall({
  //     ...AnalyticsStore.overall,
  //     mfExposureLoading: true,
  //   });
  //   getMfExposure(familyId, userId, selectedAccount2.id).then((response) => {
  //     setCategoryData(response.data);
  //     AnalyticsStore.setOverall({
  //       ...AnalyticsStore.overall,
  //       categoryExposure: response.data,
  //       mfExposureLoading: false,
  //     });
  //   });
  // }, [selectedAccount2]);

  const colorsArray = [
    // { border: "#03002F", background: "#03002F22" },
    // { border: "#810B7D", background: "#810B7D22" },
    // { border: "#810B7D", background: "#810B7D22" },
    // { border: "#DB2255", background: "#DB225522" },
    // { border: "#DB2255", background: "#DB225522" },
    // { border: "#FE7B2C", background: "#FE7B2C22" },
    // { border: "#FE7B2C", background: "#FE7B2C22" },
    // { border: "#EEAD2D", background: "#EEAD2D22" },
    // { border: "#EEAD2D", background: "#EEAD2D22" },
    // { border: "#EEAD2D", background: "#EEAD2D22" },

    { border: "#0469DC", background: "#0469DC22" },
    { border: "#59C3C3", background: "#59C3C322" },
    { border: "#DB2255", background: "#DB225522" },
    { border: "#F45B69", background: "#F45B6922" },
    { border: "#FE7B2C", background: "#FE7B2C22" },
    { border: "#FE8E48", background: "#FE8E4822" },
    { border: "#F49867", background: "#F4986722" },
    { border: "#EEAD2D", background: "#EEAD2D22" },
    { border: "#F2c838", background: "#F2c83822" },
    { border: "#f5e342", background: "#f5e34222" },
  ];

  return (
    <div>
      <div className="performers exposure__section">
        <div className="equity-card-title analytics-card">
          <h2 className="exposure__title">
            Your <b>AMC Exposure </b>
          </h2>
          {!(
            selectedAccount1.value === "Across Categories" &&
            amcData.length === 0 &&
            !AnalyticsStore.overall.amcExposureLoading
          ) && (
            <div className="exposure_dropdown">
              <span className="equity-show-me">Show me</span>
              <RadioDropdown
                selected={selectedAccount1}
                open={amcMenuOpen}
                setOpen={setAmcMenuOpen}
                position={{ top: "56px", left: "0px", right: "20px" }}
                items={marketCapDropdownItems}
                handleChange={(selectedOption) => {
                  setSelectedAccount1(selectedOption);
                  setAmcMenuOpen(false);
                }}
                menuClassName={"exposureDropdown"}
                containerRef={amcExposureDropdownContainerRef}
                ref={amcExposureDropdownButtonRef}
              />
              {/* <Dropdown
                  selected={selectedAccount1}
                  open={amcMenuOpen}
                  setOpen={setAmcMenuOpen}
                  position={{ top: "56px", left: "0px", right: "20px" }}
                  items={marketCapDropdownItems}
                  handleChange={(selectedOption) => {
                    setSelectedAccount1(selectedOption);
                    setAmcMenuOpen(false);
                  }}
                  menuClassName={"exposureDropdown"}
                /> */}
            </div>
          )}

          <div className="exposure_content_div">
            <div className="exposure_accordian_div">
              {amcData.length > 0 &&
              !AnalyticsStore.overall.amcExposureLoading ? (
                <AccordionBarChart
                  overall={true}
                  data={amcData.slice(0, amcExposureCount)}
                  colorsArray={colorsArray}
                  percentTextColor="#060F1F"
                />
              ) : (
                <EmptyScreen
                  loading={AnalyticsStore.overall.amcExposureLoading}
                />
              )}
            </div>
            {amcData.length > 0 && (
              <div className="exposure_info_div">
                {amcData?.length > amcExposureCount && (
                  <div
                    className="show_more"
                    onClick={() => setAmcExposureCount(amcExposureCount + 6)}
                  >
                    <span style={{ color: "#03002F", fontSize: "15px" }}>
                      Show More
                    </span>
                    <svg
                      width="26"
                      height="14"
                      viewBox="0 0 26 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.59448 0.624337C2.19414 0.331437 2.91765 0.580113 3.21049 1.17981C3.67945 2.14007 4.25077 3.01986 4.90614 3.80201C4.93973 3.83717 4.97078 3.87391 4.99931 3.91185C5.95556 5.02617 7.08475 5.93593 8.33202 6.58964C8.36497 6.60269 8.39762 6.61731 8.4299 6.6335C8.46732 6.65235 8.50334 6.67277 8.53793 6.69476C9.91212 7.37699 11.4231 7.75133 13 7.75133C14.5766 7.75133 16.0877 7.37699 17.4619 6.69476C17.4966 6.67277 17.5326 6.65235 17.57 6.6335C17.6024 6.61731 17.6352 6.60269 17.6682 6.58964C18.9141 5.93653 20.0422 5.02811 20.9978 3.91548C21.028 3.875 21.0612 3.83584 21.0972 3.79851C21.7514 3.01732 22.3217 2.13886 22.79 1.18017C23.0831 0.580596 23.8066 0.331921 24.4062 0.624821C25.0058 0.917842 25.2544 1.64139 24.9614 2.24097C24.5647 3.05309 24.1019 3.82255 23.5805 4.5397L25.3335 6.29275C25.8054 6.76472 25.8054 7.52972 25.3335 8.00158C24.8616 8.47355 24.0966 8.47355 23.6246 8.00158L22 6.37697C21.2981 7.06765 20.5305 7.68028 19.7079 8.20095L20.7258 10.2305C21.025 10.827 20.7841 11.5531 20.1875 11.8523C19.591 12.1515 18.8649 11.9104 18.5657 11.314L17.5549 9.2986C16.4964 9.71753 15.3752 9.9952 14.2083 10.1093V12.5847C14.2083 13.252 13.6674 13.793 13 13.793C12.3326 13.793 11.7917 13.252 11.7917 12.5847V10.1093C10.6248 9.9952 9.50351 9.71753 8.44503 9.2986L7.43426 11.314C7.13509 11.9104 6.40898 12.1515 5.81245 11.8523C5.21593 11.5531 4.97489 10.827 5.27406 10.2305L6.29199 8.20095C5.46949 7.68016 4.70192 7.06753 4.00001 6.37685L2.37526 8.00158C1.90337 8.47355 1.1383 8.47355 0.666409 8.00158C0.19453 7.52972 0.19453 6.76472 0.666409 6.29275L2.41975 4.53946C1.89838 3.82219 1.43561 3.0526 1.03895 2.24024C0.746099 1.64067 0.994822 0.917116 1.59448 0.624337Z"
                        fill="#03002F"
                      />
                    </svg>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="equity-card-title analytics-card">
          <h2 className="exposure__title">
            Your <b>MF Category Exposure</b>
          </h2>
          {!(
            selectedAccount2.value === "Across Categories" &&
            categoryData.length === 0 &&
            !AnalyticsStore.overall.mfExposureLoading
          ) && (
            <div className="exposure_dropdown">
              <span className="equity-show-me">Show me</span>
              <RadioDropdown
                selected={selectedAccount2}
                open={categoryMenuOpen}
                setOpen={setcategoryMenuOpen}
                position={{ top: "56px", left: "0px", right: "20px" }}
                items={marketCapDropdownItems1}
                handleChange={(selectedOption) => {
                  setSelectedAccount2(selectedOption);
                  setcategoryMenuOpen(false);
                }}
                menuClassName={"exposureDropdown"}
                containerRef={mfCategoryExposureDropdownContainerRef}
                ref={mfCategoryExposureDropdownButtonRef}
              />
              {/* <Dropdown
                selected={selectedAccount2}
                open={categoryMenuOpen}
                setOpen={setcategoryMenuOpen}
                position={{ top: "56px", left: "0px", right: "20px" }}
                items={marketCapDropdownItems1}
                handleChange={(selectedOption) => {
                  setSelectedAccount2(selectedOption);
                  setcategoryMenuOpen(false);
                }}
                menuClassName={"exposureDropdown"}
              /> */}
            </div>
          )}

          <div className="exposure_content_div">
            <div className="exposure_accordian_div">
              {categoryData.length > 0 &&
              !AnalyticsStore.overall.mfExposureLoading ? (
                <AccordionBarChart
                  overall={true}
                  data={categoryData.slice(0, categoryExposureCount)}
                  colorsArray={colorsArray}
                  percentTextColor="#060F1F"
                />
              ) : (
                <EmptyScreen
                  loading={AnalyticsStore.overall.mfExposureLoading}
                />
              )}
            </div>
            {categoryData.length > 0 && (
              <div className="exposure_info_div">
                {categoryData?.length > categoryExposureCount && (
                  <div
                    className="show_more"
                    onClick={() =>
                      setCategoryExposureCount(categoryExposureCount + 6)
                    }
                  >
                    <span style={{ color: "#03002F", fontSize: "16px" }}>
                      Show More
                    </span>
                    <svg
                      width="26"
                      height="14"
                      viewBox="0 0 26 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.59448 0.624337C2.19414 0.331437 2.91765 0.580113 3.21049 1.17981C3.67945 2.14007 4.25077 3.01986 4.90614 3.80201C4.93973 3.83717 4.97078 3.87391 4.99931 3.91185C5.95556 5.02617 7.08475 5.93593 8.33202 6.58964C8.36497 6.60269 8.39762 6.61731 8.4299 6.6335C8.46732 6.65235 8.50334 6.67277 8.53793 6.69476C9.91212 7.37699 11.4231 7.75133 13 7.75133C14.5766 7.75133 16.0877 7.37699 17.4619 6.69476C17.4966 6.67277 17.5326 6.65235 17.57 6.6335C17.6024 6.61731 17.6352 6.60269 17.6682 6.58964C18.9141 5.93653 20.0422 5.02811 20.9978 3.91548C21.028 3.875 21.0612 3.83584 21.0972 3.79851C21.7514 3.01732 22.3217 2.13886 22.79 1.18017C23.0831 0.580596 23.8066 0.331921 24.4062 0.624821C25.0058 0.917842 25.2544 1.64139 24.9614 2.24097C24.5647 3.05309 24.1019 3.82255 23.5805 4.5397L25.3335 6.29275C25.8054 6.76472 25.8054 7.52972 25.3335 8.00158C24.8616 8.47355 24.0966 8.47355 23.6246 8.00158L22 6.37697C21.2981 7.06765 20.5305 7.68028 19.7079 8.20095L20.7258 10.2305C21.025 10.827 20.7841 11.5531 20.1875 11.8523C19.591 12.1515 18.8649 11.9104 18.5657 11.314L17.5549 9.2986C16.4964 9.71753 15.3752 9.9952 14.2083 10.1093V12.5847C14.2083 13.252 13.6674 13.793 13 13.793C12.3326 13.793 11.7917 13.252 11.7917 12.5847V10.1093C10.6248 9.9952 9.50351 9.71753 8.44503 9.2986L7.43426 11.314C7.13509 11.9104 6.40898 12.1515 5.81245 11.8523C5.21593 11.5531 4.97489 10.827 5.27406 10.2305L6.29199 8.20095C5.46949 7.68016 4.70192 7.06753 4.00001 6.37685L2.37526 8.00158C1.90337 8.47355 1.1383 8.47355 0.666409 8.00158C0.19453 7.52972 0.19453 6.76472 0.666409 6.29275L2.41975 4.53946C1.89838 3.82219 1.43561 3.0526 1.03895 2.24024C0.746099 1.64067 0.994822 0.917116 1.59448 0.624337Z"
                        fill="#03002F"
                      />
                    </svg>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryExposure;
